import {doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import { getCollection } from "./data"

export class Zone
{
	constructor(zone,project)
	{
		this.zone = zone;
		this.project = project;
		this.id = project + "_" + zone;
	}

	async submitAsNew()
	{
		Zone.submitAsNew(this);
	}

	static async submitAsNew(z)
	{
		const {id, ...rest} = z;
		var projectRef = doc(db, "Zone", id);
		let snapshot = await getDoc(projectRef);
		if (!snapshot.exists()) {
			let resp = await setDoc(doc(db, "Zone", id), { ...rest });
			return resp;
		}
	}

	static async submitUpdate(p)
	{
		const {id, ...rest} = p;
		let resp = await setDoc(doc(db, "Zone", id), { ...rest });
		return resp;
	}

	static async getAll()
	{
		return await getCollection("Zone");
	}

	static async deleteAndUpdate(selection,zones,setZones)
	{
		zones = zones.filter( project=>{
			const key = project.id;
			if(selection.includes(key))
			{
				const activityRef = doc(db, "Zone", key);
				deleteDoc(activityRef);
				return false;
			}
			return true;
		});
		setZones(zones);
	}
}